import { render, staticRenderFns } from "./auth-popup-link.vue?vue&type=template&id=6dc44991&scoped=true&lang=pug&"
import script from "./auth-popup-link.vue?vue&type=script&lang=js&"
export * from "./auth-popup-link.vue?vue&type=script&lang=js&"
import style0 from "./auth-popup-link.vue?vue&type=style&index=0&id=6dc44991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc44991",
  null
  
)

component.options.__file = "auth-popup-link.vue"
export default component.exports